import { useTranslation } from '@mc/i18n'
import Image from 'components/LegacyImage'
import type { getArticleCategories } from 'libs/server/api/articles'

type ArticleCategory = Awaited<ReturnType<typeof getArticleCategories>>[number]

interface CategoryListItemImageProps {
  category: Pick<ArticleCategory, 'name' | 'thumbnailImageUrl'>
  ltMD?: true | false | null
}

export const CategoryListItemImage = ({
  category,
  ltMD,
}: CategoryListItemImageProps) => {
  const { t } = useTranslation('@mc/next')

  const imageSize = ltMD ? 72 : 96
  const { thumbnailImageUrl: imageUrl } = category

  if (!imageUrl) return <></>

  return (
    <Image
      className='mc-corners--circle'
      src={imageUrl}
      alt={t('articles.categoriesList.categoryImageAlt', {
        name: category.name,
      })}
      width={imageSize}
      height={imageSize}
      objectFit='cover'
    />
  )
}
